// Shared loader: the green (primary) circular spinner used by the data tables, so every
// loading state in the app looks the same. Label is optional and shown beneath the circle.
// Centered both horizontally and vertically: on a full-page/table reload it fills the
// available space and sits in the middle rather than hugging the top. `minHeight` can be
// lowered for tight containers (e.g. a small modal body).
export function Spinner({ label, minHeight = '55vh' }: { label?: string; minHeight?: string | number }) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center gap-2 text-muted w-100"
      style={{ minHeight }}
    >
      <span className="spinner-border text-primary" role="status" aria-hidden="true" />
      {label && <span>{label}</span>}
    </div>
  );
}
